import { DocumentPulse, DocumentUnderstandingSummary, ArtifactTypeChip, RecentClassification, SystemPulseState } from '../../../models/home';
import { HomePulseResponse, HomePulseArtifactTypeResponse, HomePulseRecentClassificationResponse } from '../../../models/home/dtos';

export class PulseAdapter {
  static toViewModel(dto: HomePulseResponse): DocumentPulse {
    const artifactTypes = (dto.artifactTypes ?? []).map(PulseAdapter.mapArtifactType);
    const recentClassifications = (dto.recentClassifications ?? []).map(PulseAdapter.mapRecentClassification);

    const documentsUnderstood: DocumentUnderstandingSummary = {
      totalDocuments: dto.documentsUnderstood ?? 0,
      artifactTypesDetected: artifactTypes.length,
      categoriesDetected: recentClassifications.length,
    };

    return {
      systemState: PulseAdapter.mapSystemState(dto.systemState),
      systemMessage: dto.systemMessage ?? '',
      upcoming: dto.upcoming ?? 0,
      overdue: dto.overdue ?? 0,
      documentsUnderstood,
      artifactTypes,
      recentClassifications,
    };
  }

  private static mapSystemState(state?: string | null): SystemPulseState {
    const normalized = (state ?? '').toLowerCase();
    if (normalized.includes('processing')) return 'processing';
    if (normalized.includes('attention') || normalized.includes('degraded') || normalized.includes('warning')) return 'attention';
    return 'ok';
  }

  private static mapArtifactType(item: HomePulseArtifactTypeResponse): ArtifactTypeChip {
    return {
      type: item.label ?? item.key ?? 'unknown',
      count: item.documents ?? 0,
    };
  }

  private static mapRecentClassification(item: HomePulseRecentClassificationResponse): RecentClassification {
    const artifactType = item.artifactType ?? 'unknown';
    return {
      artifactType,
      category: artifactType,
      subcategory: undefined,
    };
  }
}
